import React, { Component } from 'react';

class ContentProject extends Component {
    render() {
        const { projectData } = this.props;

        console.log("this is data", projectData);

        if (!projectData) {
            return (
                <div className="detail-gallery">
                    <div className="themesflat-spacer clearfix" data-desktop={21} data-mobile={21} data-smobile={21} />
                    <div>Loading project content...</div>
                </div>
            );
        }

        // ✅ Merge main image + gallery + remove empty values
        const images = [
            ...(projectData.mainImage ? [projectData.mainImage] : [])
                   ].filter(Boolean);

        const hasImages = images.length > 0;

        return (
            <div className="detail-gallery">
                <div className="themesflat-spacer clearfix" data-desktop={21} data-mobile={21} data-smobile={21} />
                
                {/* Gallery Section */}
                {hasImages ? (
                    <div className="themesflat-gallery style-2 has-arrows arrow-center arrow-circle offset-v-82 has-thumb w185 clearfix"
                        data-gap={0} data-column={1} data-column2={1} data-column3={1} data-auto="false">
                        <div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "10px"
  }}
>
  {images.map((img, i) => (
    <img
      key={i}
      src={img}
      alt={`project-${i}`}
      loading="lazy"
      style={{
        width: "100%",
        borderRadius: "8px",
        objectFit: "cover"
      }}
    />
  ))}
</div>
                    </div>
                ) : (
                    // Fallback to default images if no images from API
                    <div className="themesflat-gallery style-2 has-arrows arrow-center arrow-circle offset-v-82 has-thumb w185 clearfix"
                        data-gap={0} data-column={1} data-column2={1} data-column3={1} data-auto="false">
                        <div className="owl-carousel owl-theme">
                            <div className="gallery-item">
                                <div className="inner">
                                    <div className="thumb">
                                        <img src="assets/img/gallery/gallery-1-800x450.png" alt="Project gallery 1" />
                                    </div>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="inner">
                                    <div className="thumb">
                                        <img src="assets/img/gallery/gallery-2-800x450.png" alt="Project gallery 2" />
                                    </div>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="inner">
                                    <div className="thumb">
                                        <img src="assets/img/gallery/gallery-3-800x450.png" alt="Project gallery 3" />
                                    </div>
                                </div>
                            </div>
                            <div className="gallery-item">
                                <div className="inner">
                                    <div className="thumb">
                                        <img src="assets/img/gallery/gallery-4-800x450.png" alt="Project gallery 4" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
                <div className="themesflat-spacer clearfix" data-desktop={40} data-mobile={40} data-smobile={40} />
                
                {/* Project Description Section */}
                <div className="flat-content-wrap style-3 pt-5 clearfix">
                    <h5 className="title">PROJECT DESCRIPTION</h5>
                    <div className="sep has-width w60 accent-bg margin-top-18 clearfix" />
                    
                    {projectData.projectDescription ? (
                        <div className="margin-top-28">
                            {/* Split description by newlines and render as paragraphs */}
                            {projectData.projectDescription.split('\n').map((paragraph, index) => (
                                paragraph.trim() && (
                                    <p key={index} className={index === 0 ? "margin-top-28" : ""}>
                                        {paragraph}
                                    </p>
                                )
                            ))}
                        </div>
                    ) : (
                        <>
                            <p className="margin-top-28">
                                The ten-storey, 325,000 SF Krembil Discovery Centre provides the Toronto Western
                                Hospital with a new research and rehabilitation facility...
                            </p>
                            <p>
                                From November 2013 to April 2014, EllisDon was awarded an additional Lump Sum contract...
                            </p>
                        </>
                    )}
                    
                    {/* Video Section */}
                    {projectData.videoURL && (
                        <>
                            <div className="themesflat-spacer clearfix" data-desktop={30} data-mobile={30} data-smobile={30} />
                            <h5 className="title">PROJECT VIDEO</h5>
                            <div className="sep has-width w60 accent-bg margin-top-18 clearfix" />
                            <div className="video-container margin-top-28">
                                <iframe 
                                    width="100%" 
                                    height="400" 
                                    src={projectData.videoURL} 
                                    title={`${projectData.title} Video`}
                                    frameBorder="0" 
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default ContentProject;